import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  ChartBarIcon, 
  UserGroupIcon, 
  BuildingOfficeIcon, 
  CreditCardIcon,
  FolderIcon,
  UserIcon,
  BellIcon,
  HeartIcon,
  CogIcon,
  EnvelopeIcon,
  TagIcon,
  BookOpenIcon,
} from '@heroicons/react/24/outline'

const Sidebar: React.FC = () => {
  const location = useLocation()
  
  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: ChartBarIcon },
    { name: 'Users', href: '/users', icon: UserGroupIcon },
    { name: 'Organizations', href: '/organizations', icon: BuildingOfficeIcon },
    { name: 'Projects', href: '/projects', icon: FolderIcon },
    { name: 'Members', href: '/members', icon: UserIcon },
    { name: 'Invitations', href: '/invitations', icon: EnvelopeIcon },
    { name: 'Billing', href: '/billing', icon: CreditCardIcon },
    { name: 'Discount Codes', href: '/discount-codes', icon: TagIcon },
    { name: 'Notifications', href: '/notifications', icon: BellIcon },
    { name: 'System Health', href: '/health', icon: HeartIcon },
    { name: 'Education', href: '/education', icon: BookOpenIcon },
    { name: 'Settings', href: '/settings', icon: CogIcon },
  ]

  const isActiveRoute = (href: string) => {
    return location.pathname === href
  }

  return (
    <div className="w-64 bg-white border-r border-gray-200 flex flex-col">
      <div className="p-6">
        <img
          src="/thinkclass-logo-horizontal-white.png"
          alt="ThinkClass"
          className="h-8 w-auto object-contain"
        />
        <p className="mt-2 text-xs font-medium text-gray-500">Admin</p>
      </div>
      <nav className="flex-1 px-4 pb-4 space-y-1">
        {navigation.map((item) => {
          const Icon = item.icon
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`
                group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors
                ${isActiveRoute(item.href)
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-500'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }
              `}
            >
              <Icon className="mr-3 h-5 w-5 flex-shrink-0" />
              {item.name}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}

export default Sidebar
